import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Landing Page
import LandingPage from './pages/LandingPage';

// Admin Portal Components
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import SubscriptionPlans from './pages/SubscriptionPlans';
import ChangePassword from './pages/ChangePassword';
import PaymentSettings from './pages/PaymentSettings';
import PaymentApprovals from './pages/PaymentApprovals';
import AdminSettings from './pages/AdminSettings';
import BackupManagement from './pages/BackupManagement';
import Layout from './components/Layout';

// POS Application
import POSApp from './pos/POSApp';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Landing Page */}
          <Route path="/" element={<LandingPage />} />
          
          {/* POS Application Routes */}
          <Route path="/gposp/*" element={<POSApp />} />
          
          {/* Admin Portal Routes - Changed to /admin prefix for security */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={<Navigate to="/admin/dashboard" replace />}
          />
          <Route
            path="/admin/tenants"
            element={
              <ProtectedRoute>
                <Tenants />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenants"
            element={<Navigate to="/admin/tenants" replace />}
          />
          <Route
            path="/admin/tenants/:id"
            element={
              <ProtectedRoute>
                <TenantDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenants/:id"
            element={<Navigate to="/admin/tenants/:id" replace />}
          />
          <Route
            path="/admin/plans"
            element={
              <ProtectedRoute>
                <SubscriptionPlans />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/payment-settings"
            element={
              <ProtectedRoute>
                <PaymentSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/payment-approvals"
            element={
              <ProtectedRoute>
                <PaymentApprovals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/backups"
            element={
              <ProtectedRoute>
                <BackupManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/plans"
            element={<Navigate to="/admin/plans" replace />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;